import React, { useEffect, useState } from 'react';
import { UserCircleIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import { Produit, getProduits } from '../services/apiProduits';
import { CardProduit } from 'components/CardProduit';
import { Title } from 'components/base/Title';
import { Text } from 'components/base/Text';
import Section from 'components/base/Section';
import { handleApiError } from 'utils/errorHandlers';
import { ApiLoading } from 'components/ApiLoading';
import { useUser } from 'context/user-context';
import { Button } from 'components/base/Button';
import { useNavigate } from 'react-router-dom';

export const Produits: React.FC = () => {
  const { isAuthenticated } = useUser();
  const [produits, setProduits] = useState<Produit[]>([]);
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState<Record<string, string[]>>({});
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProduits = async () => {
      try {
        const data = await getProduits();
        setProduits(data);
      } catch (error: any) {
        setErrors(handleApiError(error));  
      } finally {
        setLoading(false);
      }
    };

    fetchProduits();
  }, []);

  if (errors && errors.general) {
    return <ApiLoading type="error">{errors.general[0]}</ApiLoading>;
  }

  if (loading) {
    return <ApiLoading type="loading">Chargement des produits...</ApiLoading>;
  }

  if (produits.length === 0) {
    return <ApiLoading type="no-data">Aucun produit trouvé</ApiLoading>;
  }

  return (
    <Section>
      {!isAuthenticated && (
        <div className={clsx(
          'flex gap-4 p-4 rounded-md justify-start items-center mb-6',
          'border-primary-600 border bg-primary-100 flex-col md:flex-row'
        )}>
          <UserCircleIcon className="w-10 h-10 text-primary-500 shrink-0 hidden md:block" />
          <Text className='md:max-w-lg'>
            Pour passer commande vous devez vous inscrire et vous rattacher à un groupe de livraison pour définir votre référent.
          </Text>
          <Button onClick={() => navigate('/connexion?view=register')} className='md:ml-auto'>S'inscrire</Button>
        </div>
      )}
      <Title type='display' centered className='mb-4'>Nos Produits</Title>
      <div className='grid gap-6
          grid-cols-1
          md:grid-cols-2
          justify-items-center'>
        {produits.map((produit) => {
          return (
            <CardProduit key={produit.id} 
              produit={produit}
            />
          );
        })}
      </div>
    </Section>
  );
};